import { useState } from 'react';
import {
    TextField,
    IconButton,
    Menu,
    MenuItem,
    CircularProgress,
    InputAdornment
} from '@material-ui/core';
import { LocationIcon } from '../icons';
import AutocompleteSelect from './atom/AutocompleteSelect';
import { hotelAutocomplete } from '../autocomplete';
import { useSwaggerClient } from '../hooks/useSwaggerClient';

export default function HotelFieldInput({
    value,
    onChange,
    visibleIslands = [],
    required,
    label = 'Hotel',
    error,
    helperText,
    disabled
}) {
    const [selectedIsland, setSelectedIsland] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);

    const [islands, loadingIslands] = useSwaggerClient(
        'islands',
        'getAllIslands',
        { islandList: visibleIslands },
        [],
        data => data.islands
    );

    const handleIslandClick = event => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleIslandSelect = islandId => {
        setSelectedIsland(islandId);
        onChange('');
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const selectedIslandName = islands?.find(i => i.id === selectedIsland)?.name;

    const islandButton = (
        <>
            <IconButton
                size="small"
                onClick={handleIslandClick}
                title={selectedIslandName || 'All islands'}
                style={{ marginRight: 4 }}
            >
                {loadingIslands ? (
                    <CircularProgress size={18} />
                ) : (
                    <LocationIcon color={selectedIsland ? 'primary' : 'disabled'} />
                )}
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={() => handleIslandSelect(null)} selected={!selectedIsland}>
                    All islands
                </MenuItem>
                {islands?.map(island => (
                    <MenuItem
                        key={island.id}
                        onClick={() => handleIslandSelect(island.id)}
                        selected={selectedIsland === island.id}
                    >
                        {island.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );

    return (
        <AutocompleteSelect
            key={selectedIsland}
            initCall={ids => hotelAutocomplete.init(ids, selectedIsland)}
            autocompleteCall={(search, pageSize) =>
                hotelAutocomplete.search(search, pageSize, selectedIsland)
            }
            value={value}
            setValue={onChange}
            error={error}
            helperText={helperText}
            disabled={disabled}
            renderInput={params => (
                <TextField
                    {...params}
                    label={label}
                    required={required}
                    disabled={disabled}
                    placeholder="Start typing to search..."
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                <InputAdornment position="start">{islandButton}</InputAdornment>
                                {params.InputProps.startAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
}
